import { useState, useEffect, useCallback } from 'react';
import { localNewsArticles as mockArticles } from '../mocks/localNews';

export interface NewsArticle {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  timeAgo: string;
  isBreaking?: boolean;
  isFeatured?: boolean;
  source: string;
  image: string;
  sourceUrl: string;
  summary?: string;
}

interface UseNewsArticlesReturn {
  articles: NewsArticle[];
  loading: boolean;
  error: string | null;
  lastUpdated: Date | null;
  refresh: () => Promise<void>;
}

const REFRESH_INTERVAL = 15 * 60 * 1000; // 15 minutes

export const useNewsArticles = (): UseNewsArticlesReturn => {
  const [articles, setArticles] = useState<NewsArticle[]>(mockArticles);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [lastUpdated, setLastUpdated] = useState<Date | null>(new Date());

  const fetchArticles = useCallback(async (forceRefresh = false) => {
    // No Supabase connected — use mock data directly
    setArticles(mockArticles);
    setLastUpdated(new Date());
    setLoading(false);
    setError(null);
  }, []);

  const refresh = useCallback(async () => {
    await fetchArticles(true);
  }, [fetchArticles]);

  useEffect(() => {
    fetchArticles();
  }, [fetchArticles]);

  return {
    articles,
    loading,
    error,
    lastUpdated,
    refresh
  };
};
